import { render, staticRenderFns } from "./ReportSortingSelectionCard.vue?vue&type=template&id=1cfd6992&scoped=true"
import script from "./ReportSortingSelectionCard.vue?vue&type=script&lang=ts"
export * from "./ReportSortingSelectionCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportSortingSelectionCard.vue?vue&type=style&index=0&id=1cfd6992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd6992",
  null
  
)

export default component.exports